import { render, staticRenderFns } from "./AccountRecord.vue?vue&type=template&id=1f543d20&scoped=true"
import script from "./AccountRecord.vue?vue&type=script&lang=js"
export * from "./AccountRecord.vue?vue&type=script&lang=js"
import style0 from "./AccountRecord.vue?vue&type=style&index=0&id=1f543d20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f543d20",
  null
  
)

export default component.exports